import { useState } from 'react';

import { QuotationRequest } from 'entities';

import { QuotationRequests } from './QuotationRequests';
import { ProjectInvoices } from './ProjectInvoices';
import { ProjectInvoiceCreateModal } from './ProjectInvoiceCreateModal';

import { useToggleV2 } from 'hooks';

export function Standard() {
  const [quotationRequest, setQuotationRequest] = useState<QuotationRequest | null>(null);
  const [creationOpen, creationHandlers] = useToggleV2();

  const closeModal = (): void => {
    creationHandlers.turnOff();
    setQuotationRequest(null);
  };

  const openCreation = (request: QuotationRequest): void => {
    creationHandlers.turnOn();
    setQuotationRequest(request);
  };

  return (
    <>
      <ProjectInvoiceCreateModal
        quotationRequest={quotationRequest}
        close={closeModal}
        isOpen={creationOpen}
      />

      <QuotationRequests action={openCreation} />

      <ProjectInvoices openInvoiceModal={creationHandlers.turnOn} />
    </>
  );
}
